@if (visible()) {
  <aside class="update-notice" role="status" aria-live="polite">
    <div>
      <strong i18n="@@appUpdateAvailable">Update available</strong>
      <p i18n="@@appUpdateSaveReminder">Save your changes before reloading.</p>
    </div>
    <div class="actions">
      <button mat-button type="button" (click)="updates.dismissUpdate()" i18n="@@maybeLater">Maybe later</button>
      <button
        mat-flat-button
        type="button"
        [disabled]="updates.reloading()"
        (click)="updates.reloadForUpdate()"
        i18n="@@appUpdateReload"
      >
        Reload
      </button>
    </div>
  </aside>
}
